import { jsx as _jsx } from "react/jsx-runtime";
import './FormRow.scss';
export const FormRow = ({ children }) => {
    return _jsx("div", { className: 'sg-formRow', children: children });
};
//# sourceMappingURL=FormRow.js.map